import { Controller } from '@hotwired/stimulus'

// Código postal del paso de eventos del wizard de personalización (TC-134-1.2.3.3, reunión de demo
// del 2026-10-20 del PRD-134-1).
//
// El campo solo tiene sentido con «Eventos presenciales» marcado: dice de qué provincia avisar.
// Aparece debajo, en la misma pantalla, al marcar la casilla, y desaparece al desmarcarla.
//
// Oculto va además DESHABILITADO: un campo deshabilitado ni se valida ni se envía, así que el
// `required` del código postal no bloquea "Continuar" a quien solo quiere webinars. El servidor
// pinta el estado de partida —abierto si la persona ya marcó presenciales— y este controlador
// solo lo mantiene al día con la casilla.
export default class CodigoPostalDeEventosController extends Controller {
  static targets = ['casilla', 'bloque', 'campo']

  connect () {
    this.aplica()
  }

  aplica () {
    const marcada = this.casillaTarget.checked

    this.bloqueTarget.hidden = !marcada
    this.campoTarget.disabled = !marcada
  }
}
